import React, { useEffect, useRef } from 'react';
import TopHeader from '../components/TopHeader';
import BottomHeader from '../components/BottomHeader';

function Header({ data }) {
  const ref = useRef();
  useEffect(() => {
    if (ref.current) {
      localStorage.setItem('HeaderHeight', ref.current.offsetHeight);
    }
  }, [ref.current]);
  return (
    <div
      style={{
        position: 'fixed',
        zIndex: 10,
        width: '100%',
        top: 0,
      }}
      ref={ref}
    >
      <TopHeader data={data?.address || []} />
      <BottomHeader data={data?.address || []} />
    </div>
  );
}

export default Header;
